// extracted by mini-css-extract-plugin
module.exports = {"Contents":"Contents_Contents__VlNQx","content":"Contents_content__QNSMX","title":"Contents_title__PmFis","description":"Contents_description___Rgj1"};